import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Da
 */
export const DaPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.bookingsPage]: ['/reservationer'],
  [IPageName.bookingDetailsPage]: ['/reservationer/:bookingId/details'],
  [IPageName.cancellationPage]: ['/reservationer/:bookingId/cancellation'],
};
